export type QuestionType =
  | 'RICH'
  | 'SHORT'
  | 'NUMBER'
  | 'MULTICHOICE'
  | 'CHECKBOX'
  | 'DROPDOWN'
  | 'LINEARSCALE';

interface BaseQuestion {
  id: string;
  text: string;
  type: QuestionType;
  required: boolean;
}

interface RichQuestion extends BaseQuestion {
  type: 'RICH' | 'SHORT';
}

interface NumberQuestion extends BaseQuestion {
  type: 'NUMBER';
  min_value?: number;
  max_value?: number;
}

interface MultiChoiceQuestion extends BaseQuestion {
  type: 'MULTICHOICE';
  options: string[];
}

interface CheckboxQuestion extends BaseQuestion {
  type: 'CHECKBOX';
  options: string[];
}

interface DropdownQuestion extends BaseQuestion {
  type: 'DROPDOWN';
  options: string[];
}

interface LinearScaleQuestion extends BaseQuestion {
  type: 'LINEARSCALE';
  min_value: number;
  max_value: number;
  min_label?: string;
  max_label?: string;
}

export type SurveyQuestion =
  | RichQuestion
  | NumberQuestion
  | MultiChoiceQuestion
  | CheckboxQuestion
  | DropdownQuestion
  | LinearScaleQuestion;

export enum SurveyStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
}

export interface SurveyInput {
  id?: string;
  title?: string;
  description?: string;
  anonymousEnabled?: boolean;
  pages?: string[];
}

export interface Survey {
  id: string;
  title: string;
  description: string;
  anonymousEnabled: boolean;
  pages?: string[];
  questions: SurveyQuestion[];
  status: SurveyStatus;
  createdAt: string;
  createdBy?: string;
}

type GraphQLResponse<K extends string> = {
  [key in K]: Survey;
};

export type CreateSurvey = GraphQLResponse<'createSurvey'>;
export type PatchSurvey = GraphQLResponse<'patchSurvey'>;
export type PublishSurvey = GraphQLResponse<'publishSurvey'>;
export type GetSurveyById = GraphQLResponse<'survey'>;
